import { state as offerState } from '../store/store.offer';
import { state as offerVehicleState } from '../store/store.offer-vehicle';
import { state as validationState } from '../store/store.validation';
import { MAX_MILEAGE, MSM_MILEAGE_ERRORS } from '../utils/utils.vehicle';

const onValidateMileage = (): boolean => {
  const updateErrors = (errors: Set<string>) => {
    if (!offerVehicleState.mileage || offerVehicleState.mileage <= 0) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.MILEAGE_MISSING);
    } else if (offerVehicleState.mileage > MAX_MILEAGE) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.INVALID_MILEAGE);
    } else if (
      offerState.enableMileageIneligibleEditing &&
      offerState.minimumMileageIneligibleThreshold > 0 &&
      offerVehicleState.mileage < offerState.minimumMileageIneligibleThreshold
    ) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.MIN_MILEAGE);
    } else {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS);
      return true;
    }
    return false;
  };
  return updateValidateStatus(updateErrors);
};

const updateErrorsGroupValue = (errors: Set<string>, errorsGroup: object, error: string = '') => {
  Object.values(errorsGroup).map((groupError) => {
    if (groupError !== error) {
      errors.delete(groupError);
    } else {
      errors.add(groupError);
    }
  });
};

const updateValidateStatus = (updateErrors: Function): boolean => {
  const errors = validationState.form.vehicle;
  const isValid = updateErrors(errors);
  validationState.form = {
    ...validationState.form,
    vehicle: errors,
  };
  return isValid;
};

const actions = {
  onValidateMileage,
};

export { actions };
export default actions;
